// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterShade_root__Lvp0Y"};